<template>
  <div>
    <Form
      class="c-form c-form--form"
      ref="form"
      :model="cForm.model"
      :rules="cForm.rules"
      :label-width="100"
    >
      <Form-item label="联系人" prop="contactName">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.contactName"
          placeholder="请输入联系人"
        />
      </Form-item>
      <Form-item label="电话" prop="contact">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.contact"
          placeholder="请输入电话"
        />
      </Form-item>
      <Form-item label="邮箱" prop="mail">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.mail"
          placeholder="请输入邮箱"
        />
      </Form-item>
      <Form-item label="地址" prop="address">
        <Input
          class="c-form__input"
          v-model.trim="cForm.model.address"
          placeholder="请输入地址"
        />
      </Form-item>
      <Form-item label="坐标点" prop="latLng">
        <Input
          class="c-form__input"
          :value="
            [cForm.model.latLng.lat || '', cForm.model.latLng.lng || '']
              .filter(item => !!item)
              .join(', ')
          "
          readonly
          placeholder="请选择坐标点"
          @on-focus="showMap"
        />
        <c-map ref="map" @select="selectLatLng"></c-map>
      </Form-item>
      <Form-item label="公司介绍" prop="introduction">
        <c-editor
          :html="cForm.model.introduction"
          @change="
            html => {
              $set(cForm.model, 'introduction', html);
              $refs.form.validateField('introduction');
            }
          "
        ></c-editor>
      </Form-item>
      <Form-item>
        <Button class="u-mr5" type="primary" @click="submit">
          保存
        </Button>
      </Form-item>
    </Form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import RouteParamsMixin from "@/mixins/route-params";
import FormMixin from "@/mixins/form";
import { mapState } from "vuex";

const module = "aboutSettings";

@Component({
  mixins: [RouteParamsMixin, FormMixin],
  computed: mapState({
    detail: state => state[module].detail
  })
})
export default class extends Vue {
  data() {
    return {
      cForm: {
        model: this.getFormInitModel(),
        rules: {}
      }
    };
  }

  created() {
    this.id = 1;
    this.id && this.getDetail(module, this.id);
  }

  getFormInitModel() {
    return {
      latLng: {
        lat: undefined,
        lng: undefined
      },
      introduction: ""
    };
  }

  showMap() {
    this.$refs.map.show();
    this.$refs.map.create();
  }

  selectLatLng(latLng) {
    this.cForm.model.latLng = latLng;
  }

  submit() {
    this.$refs.form.validate(async valid => {
      if (valid) {
        const {
          model: { id, ...restModel }
        } = this.cForm;

        await this.$store.dispatch(`${module}/${id ? "put" : "post"}`, {
          id,
          body: restModel
        });

        this.cForm.modal = false;
        this.$Message.success(`${id ? "编辑" : "新增"}成功`);
        this.$emit("get-list");
      }

      this.fixFormButtonLoading();
    });
  }
}
</script>
